// extracted by mini-css-extract-plugin
module.exports = {"button":"popup_button__wNCXX","disabledOutline":"popup_disabledOutline__IGQyF","heading":"popup_heading__Pvt4X"};